<template>
    <div class="option" ref="option" :class="className" @click="handleClick">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name:"Option",
    props:{
        active: Boolean,
        checkbox: Boolean,
        disabled: Boolean,
        disabledTrigger: Boolean
    },
    computed:{
        className(){
            return {
                'is-checkbox': this.checkbox,
                'is-active': this.active,
                'is-disabled': this.disabled
            };
        }
    },
    methods: {
        handleClick(){
            this.$emit('click', ...arguments);
        }
    }
}
</script>
<style lang="scss">
*>.option:last-of-type{
    margin-bottom: 0;
}
.option{
    width: 100%;
    min-height: 88px;
    padding: 22px 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    background-color: #FAFBFA;
    &{
        line-height: 44px;
        font-size: 32px;
        color: #2F343C;
        text-align: center;
        font-weight: 400;
		word-break: break-all;
    }
    &.is-active,
    &.is-active.is-disabled{
        background-color: #7AD21A;
        color: #fff;
        font-weight: 500;
    }
    &.is-disabled{
        color: #BFC1C5;
        background-color: #FAFBFA;
    }
    &.is-checkbox{
        @include bg-image('~@images/icon/icon_check_unselected');
        background-repeat: no-repeat;
        background-size: 48px 48px;
        background-position: calc(100% - 16px) 50%;
        padding-right: 84px;
        &.is-active{
            color: #7AD21A;
            @include bg-image('~@images/icon/icon_check_selected');
            background-color: #FAFBFA;
        }
    }
    &.is-active.is-disabled{
        position: relative;
        &::after{
            content:"";
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 8px;
            background: rgba(255,255,255,0.4);
        }
    }
}
</style>